import { startCase } from 'lodash';
var positionAcronyms = ['CEO', 'CTO', 'CFO', 'COO', 'VP', 'SVP', 'EVP', 'MD', 'GM'];
export var formatPositionAcronym = function (position) {
  return position.split(' ').map(function (word) {
    return positionAcronyms.includes(word.toUpperCase()) ? word.toUpperCase() : startCase(word.toLowerCase());
  }).join(' ');
};